export const toneBadge: Record<string, string> = {
  red: 'bg-red-500/10 text-red-600 ring-red-500/20',
  amber: 'bg-amber-500/10 text-amber-700 ring-amber-500/25',
  teal: 'bg-teal-500/10 text-teal-700 ring-teal-500/20',
  stone: 'bg-stone-500/10 text-stone-600 ring-stone-500/25',
};

export const toneDot: Record<string, string> = {
  red: 'bg-red-500',
  amber: 'bg-amber-500',
  teal: 'bg-teal-500',
  stone: 'bg-stone-400',
};

export const formatCount = (n: number) => {
  if (n >= 10000) return `${(n / 10000).toFixed(1)}万`;
  return `${n}`;
};